const _0x1ecee7 = _0x1a72;
(function (_0x278d0a, _0x225f6a) {
  const _0x40855d = _0x1a72,
    _0x42f187 = _0x278d0a();
  while (!![]) {
    try {
      const _0x1c3726 =
        -parseInt(_0x40855d(0x127)) / 0x1 +
        -parseInt(_0x40855d(0xd9)) / 0x2 +
        (-parseInt(_0x40855d(0xd5)) / 0x3) *
          (-parseInt(_0x40855d(0x111)) / 0x4) +
        parseInt(_0x40855d(0xfd)) / 0x5 +
        (parseInt(_0x40855d(0xf7)) / 0x6) *
          (-parseInt(_0x40855d(0x12c)) / 0x7) +
        parseInt(_0x40855d(0x116)) / 0x8 +
        (parseInt(_0x40855d(0x11e)) / 0x9) *
          (-parseInt(_0x40855d(0x109)) / 0xa);
      if (_0x1c3726 === _0x225f6a) break;
      else _0x42f187["push"](_0x42f187["shift"]());
    } catch (_0x2b7b6d) {
      _0x42f187["push"](_0x42f187["shift"]());
    }
  }
})(_0xa8d2, 0x9818b);
class VariantSelects extends HTMLElement {
  constructor() {
    const _0x415c3e = _0x1a72;
    super(),
      this[_0x415c3e(0x124)]("change", this[_0x415c3e(0x10c)]),
      this[_0x415c3e(0x10c)]();
  }
  [_0x1ecee7(0x10c)]() {
    const _0x3bcab0 = _0x1ecee7;
    this[_0x3bcab0(0xd7)](),
      this["updateMasterId"](),
      this[_0x3bcab0(0x103)](!![], "", ![]),
      this["updatePickupAvailability"](),
      !this[_0x3bcab0(0x13e)]
        ? (this[_0x3bcab0(0x103)](!![], "", !![]), this[_0x3bcab0(0xfa)]())
        : (this[_0x3bcab0(0x13b)](),
          this[_0x3bcab0(0x112)](),
          this[_0x3bcab0(0x13d)](),
          this["renderProductInfo"]());
  }
  [_0x1ecee7(0xd7)]() {
    const _0x56944e = _0x1ecee7;
    this[_0x56944e(0x10b)] = Array["from"](
      this[_0x56944e(0xda)]("select"),
      (_0x3fb1a8) => _0x3fb1a8[_0x56944e(0xe7)]
    );
  }
  [_0x1ecee7(0x11f)]() {
    const _0x1406e2 = _0x1ecee7;
    (this[_0x1406e2(0x13e)] = this[_0x1406e2(0x13f)]()[_0x1406e2(0x105)](
      (_0x2d8e66) => {
        const _0x62069f = _0x1406e2;
        return !_0x2d8e66[_0x62069f(0x10b)]
          [_0x62069f(0xd3)]((_0x468d64, _0x1c6517) => {
            return this["options"][_0x1c6517] === _0x468d64;
          })
          ["includes"](![]);
      }
    )),
      (this[_0x1406e2(0x135)] = this["getVariantMetafields"]()[
        _0x1406e2(0x105)
      ]((_0x1a8454) => _0x1a8454[this[_0x1406e2(0x13e)]["id"]] !== undefined)),
      (this["variantMetafield"] =
        this[_0x1406e2(0x135)][this[_0x1406e2(0x13e)]["id"]]);
  }
  [_0x1ecee7(0x13b)]() {
    const _0x42b08a = _0x1ecee7;
    if (!this[_0x42b08a(0x13e)] || !this["currentVariant"]?.["featured_media"])
      return;
    const _0x23f1ea = document[_0x42b08a(0xde)](
      _0x42b08a(0xf8) +
        this["dataset"][_0x42b08a(0x131)] +
        "-" +
        this[_0x42b08a(0x13e)][_0x42b08a(0xe6)]["id"] +
        "\x22]"
    );
    if (!_0x23f1ea) return;
    const _0x2da7df = _0x23f1ea[_0x42b08a(0x115)];
    _0x2da7df["prepend"](_0x23f1ea),
      window[_0x42b08a(0x128)](() => {
        const _0x1c26ff = _0x42b08a;
        _0x2da7df[_0x1c26ff(0xd6)](0x0, 0x0);
      });
  }
  [_0x1ecee7(0x112)]() {
    const _0x40e3f5 = _0x1ecee7;
    if (!this["currentVariant"]) return;
    window[_0x40e3f5(0x133)][_0x40e3f5(0xeb)](
      {},
      "",
      this[_0x40e3f5(0xf9)][_0x40e3f5(0x11b)] +
        _0x40e3f5(0xec) +
        this[_0x40e3f5(0x13e)]["id"]
    );
  }
  [_0x1ecee7(0x13d)]() {
    const _0x2f6bf5 = _0x1ecee7,
      _0x48b58a = document["querySelectorAll"](
        _0x2f6bf5(0xe4) +
          this[_0x2f6bf5(0xf9)][_0x2f6bf5(0x131)] +
          _0x2f6bf5(0xe0)
      );
    _0x48b58a[_0x2f6bf5(0x10e)]((_0x67aeeb) => {
      const _0x363974 = _0x2f6bf5,
        _0x279070 = _0x67aeeb[_0x363974(0xde)](_0x363974(0x121));
      (_0x279070["value"] = this["currentVariant"]["id"]),
        _0x279070["dispatchEvent"](
          new Event(_0x363974(0xe9), { bubbles: !![] })
        );
    });
  }
  ["updatePickupAvailability"]() {
    const _0x18ff00 = _0x1ecee7,
      _0x1b21e3 = document[_0x18ff00(0xde)](_0x18ff00(0x119));
    if (!_0x1b21e3) return;
    this["currentVariant"]?.[_0x18ff00(0xdc)]
      ? _0x1b21e3[_0x18ff00(0xf6)](this[_0x18ff00(0x13e)]["id"])
      : (_0x1b21e3["removeAttribute"](_0x18ff00(0xdc)),
        (_0x1b21e3[_0x18ff00(0xff)] = ""));
  }
  [_0x1ecee7(0x132)]() {
    const _0x1f4a27 = _0x1ecee7;
    fetch(
      this["dataset"][_0x1f4a27(0x11b)] +
        _0x1f4a27(0xec) +
        this[_0x1f4a27(0x13e)]["id"] +
        _0x1f4a27(0x120) +
        this["dataset"][_0x1f4a27(0x131)]
    )
      [_0x1f4a27(0x139)]((_0x341ee4) => _0x341ee4["text"]())
      [_0x1f4a27(0x139)]((_0x2b7f7a) => {
        const _0x20955a = _0x1f4a27,
          _0x44b26b = _0x20955a(0xe8) + this[_0x20955a(0xf9)][_0x20955a(0x131)],
          _0x45dcff = new DOMParser()["parseFromString"](
            _0x2b7f7a,
            _0x20955a(0x12d)
          ),
          _0x253465 = document[_0x20955a(0xd4)](_0x44b26b),
          _0x4de3b8 = _0x45dcff[_0x20955a(0xd4)](_0x44b26b);
        if (_0x4de3b8 && _0x253465)
          _0x253465[_0x20955a(0xff)] = _0x4de3b8[_0x20955a(0xff)];
        document[_0x20955a(0xd4)](
          _0x20955a(0xe8) + this["dataset"]["section"]
        )?.[_0x20955a(0xe1)][_0x20955a(0x12a)](_0x20955a(0x102));
        if (this[_0x20955a(0x13e)][_0x20955a(0xdc)])
          this[_0x20955a(0x103)](![], variantStrings[_0x20955a(0x117)]),
            (document["getElementById"]("preorderbunner")[_0x20955a(0xff)] =
              ""),
            (document["getElementById"](_0x20955a(0x11c))["innerHTML"] = "");
        else {
          this[_0x20955a(0x103)](!![], variantStrings[_0x20955a(0x137)]);
          let _0x3117d4 =
            _0x20955a(0x11d) +
            this[_0x20955a(0x13e)]?.[_0x20955a(0xf1)][_0x20955a(0xfe)](
              this[_0x20955a(0x13e)]?.[_0x20955a(0x114)],
              ""
            ) +
            _0x20955a(0x110) +
            this[_0x20955a(0x13e)]?.[_0x20955a(0x114)] +
            _0x20955a(0x11a);
          document["getElementById"]("preorderbunner")[_0x20955a(0xff)] =
            _0x3117d4;
        }
        if (this[_0x20955a(0x113)]?.[_0x20955a(0x122)] !== undefined) {
           const _0x42a46a = this[_0x20955a(0x113)]?.["type"]
          //const _0x42a46a = 'Ships_out'
            [_0x20955a(0x126)]("_")
            [_0x20955a(0xf4)]("\x20");
          let _0x163496 = _0x20955a(0x108) + _0x42a46a + "</h3>";
          if (this[_0x20955a(0x113)]?.[_0x20955a(0x122)] === "pre_order")
            (_0x163496 +=
              "<p\x20class=\x22message\x22>FYI,\x20" +
              this[_0x20955a(0x13e)][_0x20955a(0xf1)] +
              "\x20" +
              this[_0x20955a(0x113)]?.[_0x20955a(0x106)] +
              _0x20955a(0x138) +
              this[_0x20955a(0xdf)](this[_0x20955a(0x113)]?.[_0x20955a(0xea)])),
              (document[_0x20955a(0xd4)](_0x20955a(0x11c))["innerHTML"] =
                _0x20955a(0xed) +
                this["variantMetafield"]?.[_0x20955a(0x106)] +
                "\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<input\x20type=\x22hidden\x22\x20name=\x22pre_order_expected_date\x22\x20value=\x22" +
                this[_0x20955a(0x113)]?.[_0x20955a(0xea)] +
                "\x22>");
              // "\x22>"),
               // this[_0x20955a(0x103)](![], _0x42a46a);
          else {
            if (
              this["variantMetafield"]?.[_0x20955a(0x122)] === _0x20955a(0x107)
            ) {
              const _0x3b451e = [
                  "",
                  "January",
                  "February",
                  _0x20955a(0xf0),
                  _0x20955a(0x12b),
                  _0x20955a(0xdd),
                  _0x20955a(0xe5),
                  _0x20955a(0x100),
                  _0x20955a(0xfc),
                  "September",
                  _0x20955a(0xe3),
                  _0x20955a(0x10a),
                  "December",
                ],
                _0x3a4e29 =
                  this[_0x20955a(0x113)]?.[_0x20955a(0xea)][_0x20955a(0x126)](
                    "-"
                  ),
                _0x2ca639 = new Date()[_0x20955a(0xf5)]();
              let _0x4fdcbc = "";
              _0x3a4e29[0x0] * 0x1 == _0x2ca639
                ? (_0x4fdcbc =
                    _0x3b451e[_0x3a4e29[0x1] * 0x1] +
                    "\x20" +
                    _0x3a4e29[0x2] +
                    "")
                : (_0x4fdcbc =
                    _0x3b451e[_0x3a4e29[0x1] * 0x1] +
                    "\x20" +
                    _0x3a4e29[0x2] +
                    "th,\x20" +
                    _0x3a4e29[0x0]),
                (_0x163496 += _0x3a4e29
                  ? "<p\x20class=\x22message\x22>Launches\x20" +
                    _0x4fdcbc +
                    _0x20955a(0xd8)
                  : ""),
                (document[_0x20955a(0xd4)](_0x20955a(0x11c))[_0x20955a(0xff)] =
                  "");
            } else
              (_0x163496 +=
                _0x20955a(0x12f) +
                this[_0x20955a(0x13e)]?.[_0x20955a(0xf1)]["replace"](
                  this[_0x20955a(0x13e)]?.[_0x20955a(0x114)],
                  ""
                ) +
                _0x20955a(0x110) +
                this[_0x20955a(0x13e)]?.[_0x20955a(0x114)] +
                _0x20955a(0x138)),
                (document[_0x20955a(0xd4)]("bc-order-id")["innerHTML"] = ""),
                this["setUnavailable"]();
          }
          (_0x163496 += "</div>"),
            (document[_0x20955a(0xd4)]("preorderbunner")[_0x20955a(0xff)] =
              _0x163496);
        }
      });
  }
  [_0x1ecee7(0x103)](_0x371ab9 = !![], _0x492afe, _0x4eacab = !![]) {
    const _0x5a2d61 = _0x1ecee7,
      _0x5b457c = document[_0x5a2d61(0xd4)](
        _0x5a2d61(0x10d) + this[_0x5a2d61(0xf9)][_0x5a2d61(0x131)]
      )?.[_0x5a2d61(0xde)]("[name=\x22add\x22]");
    if (!_0x5b457c) return;
    if (_0x371ab9) {
      _0x5b457c[_0x5a2d61(0x123)]("disabled", !![]),
        _0x5b457c[_0x5a2d61(0xe1)][_0x5a2d61(0xfb)](_0x5a2d61(0xee));
      if (_0x492afe)
        _0x5b457c[_0x5a2d61(0xde)](_0x5a2d61(0xef))[_0x5a2d61(0x134)] =
          _0x492afe;
    } else
      _0x5b457c[_0x5a2d61(0xe2)](_0x5a2d61(0x125)),
        _0x5b457c[_0x5a2d61(0xe1)][_0x5a2d61(0x12a)]("bc-sold-out");
        (_0x5b457c[_0x5a2d61(0xde)](_0x5a2d61(0xef))[_0x5a2d61(0x134)] =
           _0x492afe);
    
    
    if (!_0x4eacab) return;
  }
  [_0x1ecee7(0xfa)]() {
    const _0x4b55de = _0x1ecee7,
      _0x16c61a = document["getElementById"](
        "product-form-" + this[_0x4b55de(0xf9)][_0x4b55de(0x131)]
      )?.[_0x4b55de(0xde)](_0x4b55de(0x130));
    if (!_0x16c61a) return;
    (_0x16c61a[_0x4b55de(0x134)] = window[_0x4b55de(0x10f)][_0x4b55de(0x101)]),
      document["getElementById"](
        _0x4b55de(0xe8) + this[_0x4b55de(0xf9)][_0x4b55de(0x131)]
      )?.["classList"][_0x4b55de(0xfb)](_0x4b55de(0x102));
  }
  [_0x1ecee7(0x13f)]() {
    const _0x2bfdcb = _0x1ecee7;
    return (
      (this[_0x2bfdcb(0x104)] =
        this[_0x2bfdcb(0x104)] ||
        JSON[_0x2bfdcb(0xdb)](
          this[_0x2bfdcb(0xde)]("[type=\x22application/json\x22]")[
            _0x2bfdcb(0x134)
          ]
        )),
      this[_0x2bfdcb(0x104)]
    );
  }
  [_0x1ecee7(0x129)]() {
    const _0x527b3e = _0x1ecee7;
    return (
      (this[_0x527b3e(0x12e)] =
        this[_0x527b3e(0x12e)] ||
        JSON["parse"](
          this[_0x527b3e(0xde)](_0x527b3e(0x13c))[_0x527b3e(0x134)]
        )),
      this["variantMetafields"]
    );
  }
  ["getPreOrderModal"](_0x56005f) {
    const _0x1a9872 = _0x1ecee7;
    let _0xf5e2c7 =
      _0x1a9872(0xf3) +
      _0x56005f +
      "\x20date)\x20it\x20will\x20ship\x20immediately\x20and\x20the\x20remaining\x20items\x20will\x20ship\x20out\x20when\x20we\x20receive\x20them\x20in\x20our\x20warehouse\x20in\x20a\x20separate\x20package.\x20Please\x20email\x20us\x20if\x20you\x20have\x20any\x20questions.</p>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20</div>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20</modal-dialog>";
    return _0xf5e2c7;
  }
}
function _0xa8d2() {
  const _0x4c0bb2 = [
    "&section_id=",
    "input[name=\x22id\x22]",
    "type",
    "setAttribute",
    "addEventListener",
    "disabled",
    "split",
    "856836BEfUIh",
    "setTimeout",
    "getVariantMetafields",
    "remove",
    "April",
    "103117RKOXQJ",
    "text/html",
    "variantMetafields",
    "<p\x20class=\x22message\x22>Sorry,\x20",
    "[name=\x22add\x22]",
    "section",
    "renderProductInfo",
    "history",
    "textContent",
    "cuurentMetafield",
    "fieldset",
    "soldOut",
    ".</p>",
    "then",
    "variant-selects",
    "updateMedia",
    "#product-variants-metafields",
    "updateVariantInput",
    "currentVariant",
    "getVariantData",
    "map",
    "getElementById",
    "2875710eTxBEo",
    "scroll",
    "updateOptions",
    "</p>",
    "832782bGvgqx",
    "querySelectorAll",
    "parse",
    "available",
    "May",
    "querySelector",
    "getPreOrderModal",
    ",\x20#product-form-installment",
    "classList",
    "removeAttribute",
    "October",
    "#product-form-",
    "June",
    "featured_media",
    "value",
    "price-",
    "change",
    "pre_order_expected_date",
    "replaceState",
    "?variant=",
    "<input\x20type=\x22hidden\x22\x20name=\x22pre\x22\x20value=\x22order\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<input\x20type=\x22hidden\x22\x20name=\x22pre_order_announcement\x22\x20value=\x22",
    "bc-sold-out",
    "span.product-form__submit-label",
    "March",
    "name",
    "define",
    "<modal-opener\x20class=\x22product-popup-modal__opener\x20no-js-hidden\x22\x20data-modal=\x22#PopupModal-preorder\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<button\x20id=\x22ProductPopup-preorder\x22\x20class=\x22product-popup-modal__button\x20link\x20bc-pre-order-learn\x22\x20type=\x22button\x22\x20aria-haspopup=\x22dialog\x22>Learn\x20more\x20here</button>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20</modal-opener>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<modal-dialog\x20id=\x22PopupModal-preorder\x22\x20class=\x22product-popup-modal\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<div\x20role=\x22dialog\x22\x20aria-modal=\x22true\x22\x20class=\x22product-popup-modal__content\x22\x20tabindex=\x22-1\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<button\x20id=\x22ModalClose-preorder\x22\x20type=\x22button\x22\x20class=\x22product-popup-modal__toggle\x22\x20aria-label=\x22Close\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<svg\x20xmlns=\x22http://www.w3.org/2000/svg\x22\x20aria-hidden=\x22true\x22\x20focusable=\x22false\x22\x20role=\x22presentation\x22\x20class=\x22icon\x20icon-close\x22\x20fill=\x22none\x22\x20viewBox=\x220\x200\x2018\x2017\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<path\x20d=\x22M.865\x2015.978a.5.5\x200\x2000.707.707l7.433-7.431\x207.579\x207.282a.501.501\x200\x2000.846-.37.5.5\x200\x2000-.153-.351L9.712\x208.546l7.417-7.416a.5.5\x200\x2010-.707-.708L8.991\x207.853\x201.413.573a.5.5\x200\x2010-.693.72l7.563\x207.268-7.418\x207.417z\x22\x20fill=\x22currentColor\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20</path></svg>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20</button>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<h2>SPECIAL\x20ORDERS</h2>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<p>Any\x20order\x20that\x20has\x20a\x20specific\x20ship\x20out\x20date\x20will\x20ship\x20out\x20close\x20to\x20that\x20date.\x20If\x20you\x20order\x20anything\x20else\x20that\x20is\x20currently\x20in\x20stock\x20(does\x20not\x20say\x20ships\x20out\x20on\x20",
    "join",
    "getFullYear",
    "fetchAvailability",
    "108sBprlW",
    "[data-media-id=\x22",
    "dataset",
    "setUnavailable",
    "add",
    "August",
    "4701755myQeDo",
    "replace",
    "innerHTML",
    "July",
    "unavailable",
    "visibility-hidden",
    "toggleAddButton",
    "variantData",
    "find",
    "pre_order",
    "coming_soon",
    "<div\x20class=\x22bc-order-wrapper\x22><h3\x20class=\x22title\x22>",
    "1475260upOWfk",
    "November",
    "options",
    "onVariantChange",
    "product-form-",
    "forEach",
    "variantStrings",
    "\x20is\x20sold\x20out\x20in\x20size\x20",
    "4rirdBE",
    "updateURL",
    "variantMetafield",
    "title",
    "parentElement",
    "3279816qCKLBm",
    "addToCart",
    "variant-radios",
    "pickup-availability",
    ".</p>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20</div>",
    "url",
    "bc-order-id",
    "<div\x20class=\x22bc-order-wrapper\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<h3\x20class=\x22title\x22>Sold\x20Out</h3>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<p\x20class=\x22message\x22>Sorry,\x20",
    "9TkHJPx",
    "updateMasterId",
  ];
  _0xa8d2 = function () {
    return _0x4c0bb2;
  };
  return _0xa8d2();
}
customElements[_0x1ecee7(0xf2)](_0x1ecee7(0x13a), VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  [_0x1ecee7(0xd7)]() {
    const _0x3fce9e = _0x1ecee7,
      _0xafac88 = Array["from"](this[_0x3fce9e(0xda)](_0x3fce9e(0x136)));
    this[_0x3fce9e(0x10b)] = _0xafac88[_0x3fce9e(0xd3)]((_0x137331) => {
      const _0x3e736d = _0x3fce9e;
      return Array["from"](_0x137331[_0x3e736d(0xda)]("input"))[
        _0x3e736d(0x105)
      ]((_0x4b7bff) => _0x4b7bff["checked"])[_0x3e736d(0xe7)];
    });
  }
}
function _0x1a72(_0x527c27, _0x4ee70c) {
  const _0xa8d20d = _0xa8d2();
  return (
    (_0x1a72 = function (_0x1a726e, _0x32b474) {
      _0x1a726e = _0x1a726e - 0xd3;
      let _0x5a3213 = _0xa8d20d[_0x1a726e];
      return _0x5a3213;
    }),
    _0x1a72(_0x527c27, _0x4ee70c)
  );
}
customElements[_0x1ecee7(0xf2)](_0x1ecee7(0x118), VariantRadios);

var title = $('h1.product__title').text();

$('input[type=radio][name=Size],input[type=radio][name=SIZE]').change(function () {
  $('#preorderbunner1').hide();
    var dtitle = $(this).attr("data-shiptitle");
    var ddesc = $(this).attr("data-shipdesc");
    var ddate = $(this).attr("data-expecteddate");
    var dpreorder = $(this).attr("data-preorder");
    var size_att = $(this).attr("value");
    
 
    if (dtitle != '') {
      dtitle = dtitle;
    } else {
      dtitle = dpreorder.replace('_' , ' ');
      if(dtitle == 'pre order'){
        dtitle = 'Ships Out';
        //ddesc = 'Will Ship Out ' + ddesc;
      }
    }
    $(".title1").text(dtitle);
    if (dtitle.toLowerCase().indexOf('coming soon') != -1 || dpreorder.toLowerCase().indexOf('coming_soon') != -1) {
        if (ddate != '') {
            var final_msg = 'Launches ' + ddate;
            $('#bc-order-wrapper1').addClass('wrapper-border');
            $(".message1").text(final_msg);
          $('#preorderbunner1').show();
        }
    }
    else {
        var final_msg = 'FYI,' + ' ' + title + ' ' + size_att + ' - ' + ddesc;
        if (ddesc != '') {
            $('#bc-order-wrapper1').addClass('wrapper-border');
            $(".message1").text(final_msg);
          $('#preorderbunner1').show();
        }
    }
  //ddesc = ' ';

});

$(document).ready(function () {
    let obj;
    let sizes = $('input[name="Size"]');
    /*if($('input[name="SIZE"]')){
      sizes = $('input[name="SIZE"]');
    };*/
    $(sizes).each(function(){
      if($(this).prop("checked")) obj = this;
    });
    
    var etitle = $(obj).attr("data-shiptitle");
    var desc = $(obj).attr("data-shipdesc");
    var ddate = $(obj).attr("data-expecteddate");
    var dpreorder = $(obj).attr("data-preorder");
    var size_at = $(obj).attr("value");
  
    if (etitle != '') {
      etitle = etitle;
    } else {
      etitle = dpreorder.replace('_' , ' ');
      if(etitle == 'pre order'){
        etitle = 'Ships Out';
        //desc = 'Will Ship Out ' + desc;
      }
    }
  
    $(".title1").text(etitle);
    if (etitle.toLowerCase().indexOf('coming soon') != -1 || dpreorder.toLowerCase().indexOf('coming_soon') != -1) {
        if (ddate != '') {
            var final_msgg = 'Launches ' + ddate;
            $('#bc-order-wrapper1').addClass('wrapper-border');
            $(".message1").text(final_msgg);
        }
    } else {
        var final_msgg = 'FYI,' + ' ' + etitle + ' ' + size_at + ' - ' + desc;

        if (desc != '') {
            $('#bc-order-wrapper1').addClass('wrapper-border');
            $(".message1").text(final_msgg);
        }
    }
});

